import styled from "styled-components";

export const Wrapper = styled.section`
  padding:10px 16px ;
  gap: 32px;

  @media (min-width: 768px){
    padding: 32px 64px;
  }
  @media (min-width: 1440px) {
    padding: 48px 120px;
  }
`;

/* largura máxima + grid responsivo */
export const Container = styled.div`
  max-width: 1200px;
  margin: 0 auto;

  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;

  @media (min-width: 1200px){
    grid-template-columns: 1.1fr 0.9fr;
    gap: 32px;
    align-items: start;
  }
`;

export const Header = styled.header`
  display: grid;
  gap: 16px;
  grid-column: 1 / -1;
  text-align: left;

  h3{
    font-weight: 600;
    font-style: bold;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 1px;
    max-width: 500px;
  }
  p{
    font-weight: 400;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0px;

  }

  .first{
      display: block;

      @media (min-width: 600px){
        display: none;
      }
    }
`;

export const CardsCol = styled.div`
  display: grid;
  gap: 16px;

  @media (min-width: 768px){
    gap: 32px;
  }
`;

export const Card = styled.article`
  border-radius: 16px;
  padding: 1px;
  background:
    radial-gradient(160px 50px at 50% -22px,
      #2a73ff 0%,
      rgba(42,115,255,0.55) 50%,
      rgba(42,115,255,0) 70%) border-box,
    linear-gradient(#363636, #363636) border-box;

  /* efeitos já existentes */
  .colors{
    height: 156px;
    width: 156px;
    border-radius: 100%;
    filter: blur(var(--blur, 100px));
    opacity: var(--alpha, 1);
    mix-blend-mode: screen;
    will-change: transform, filter;
    position: absolute;
  }
  .blue{ background-color: #2A73FF80; top: -70px; right: -70px; }
  .pink{ background-color: #D7208280; bottom: -70px; left: -70px; }

  .module{
    background-color: #000;
    padding: 16px;
    border-radius: 16px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    text-align: left;
    position: relative;
    box-sizing: border-box;
    overflow: hidden;
    transition: transform .35s ease, filter .35s ease, box-shadow .35s ease;
    will-change: transform, filter, box-shadow;
  }

  /* --- realce quando o card fica ativo pelo scroll --- */
  &[data-active="true"] .module{
    transform: translateY(-2px) scale(1.01);
    filter: brightness(1.05) saturate(1.05);
    box-shadow: 0 12px 30px rgba(0,87,255,0.18);
  }

  /* borda/halo extra só quando ativo (não altera dimensões) */
  &[data-active="true"]::after{
    content:"";
    position:absolute; 
    inset:0; 
    border-radius:16px; 
    pointer-events:none;
   
    opacity: .85;
    padding: 1px;
    -webkit-mask: linear-gradient(#000 0 0) content-box, linear-gradient(#000 0 0);
    -webkit-mask-composite: xor; mask-composite: exclude;
  }

  @media (prefers-reduced-motion: reduce){
    .module{ transition: none; }
  }
`;

export const StepPill = styled.span`
  background-color: var(--color-181818);
  width: 95px;
  height: 40px;
  gap: 10px;
  opacity: 1;
  border-radius: 8px;
  border-width: 1px;
  padding:8px 16px;
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
`;

export const CardTitle = styled.h4`
  font-weight: 600;
  font-style: bold;
  font-size: 24px;
  line-height: 32px;
  letter-spacing: 1px;
  text-transform: capitalize;
  background: linear-gradient(90deg, var(--color-2a73ff) 0%, var(--color-8A69BE) 15%, var(--color-d72082) 25%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  color: transparent;
`;

export const CardBody = styled.p`
  font-weight: 400;
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
`;

export const Tags = styled.div`
  display:flex;
  flex-wrap:wrap;
  gap:10px;
`;

export const Tag = styled.span`
  width: fit-content;
  height: 24px;
  gap: 10px;
  opacity: 1;
  border-radius: 128px;
  padding:4px 8px;
  font-weight: 400;
  font-size: 12px;
  line-height: 16px;
  letter-spacing: 0px;
  background-color: var(--color-6A2AFF);
`;

export const Sticky = styled.div`
  display: none;
  position: relative;

  @media (min-width: 1200px){
    position: sticky;
    top: 96px;                 /* cola sob o topo */
    width: fit-content;
    height: fit-content;
    display: block;
    transform: translateY(var(--parallax, 0px)); /* parallax */
    will-change: transform;
  }
`;

export const ImageFrame = styled.div`
  display: none;

  @media (min-width: 1200px){
    width: 544px;
    overflow: hidden;
    position: relative;
    height: 460px;
    display: block;
  }
`;

export const SwapImage = styled.img`
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity .35s ease;
  filter: contrast(1.05) saturate(1.05);

  &.is-active { opacity: 1; }
`;
